module.exports = __webpack_public_path__ + "static/oas-seal-vertical-slim-c681fc9743c404f86903decaff1723ba.png";